module.exports = __webpack_public_path__ + "media/V78.19ca2545.mp4";